import { Component } from '@angular/core';
import { CellViewBase } from '../base';

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text-plain',
    template: '{{data[column.prop]}}',
    standalone: false,
})
export class TextPlainComponent extends CellViewBase {}
